import { client } from "@lib/api"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import * as Sentry from "@sentry/react"

const useVirtualAccountDeposit = () => {
   const { t } = useTranslation()
   const [isLoading, setIsLoading] = useState(false)
   const [error, setError] = useState<string | null>(null)

   const createVirtualAccountDeposit = async (bankCode: string, amount: number) => {
    // Reset error state before starting a new request
    setError(null)
    
    try {
        setIsLoading(true)
        const response = await client.doPost('/v2/wallet/virtual-account', {
            bank_code: bankCode,
            ui_amount: String(amount)
        })
        return response
    } catch (error) {
        Sentry.captureException(error)
        setError(t('errors.1009.description'))
        throw error
    } finally {
        setIsLoading(false)
    }
   }

   return {
    createVirtualAccountDeposit,
    isLoading,
    error
   }
}

export default useVirtualAccountDeposit
